import React, {useEffect} from 'react'
import styled from 'styled-components'
import Header from '../Header'
import Footer from '../Footer'
import emailjs from 'emailjs-com'


function Contact() {

    function sendEmail(e){
        e.preventDefault();
        console.log(e.target);
        emailjs.sendForm('service_sjnimro', 'template_d0yfw6h', e.target, 'user_vKLtBLy3sWqstDKzPwIgZ')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
        });

        e.target.reset();
    }

    useEffect(()=>{
        window.scrollTo(0,0)
      },[])

    return (
        <>
            <Header />
            <Banner>
                <div className="banner__container">
                        <div className="banner__content">
                            <h2>Contact Us</h2>
                            <p>We are always available to hear from you</p>
                        </div>
                        <div className="banner__background"></div>
                    </div>
            </Banner>
            <Main>
                <div className="container">
                    <div className="main__caption">
                        <span>Let's discuss</span>
                        <h2>Whatever question you have, please feel free to ask.</h2>
                    </div>
                    <div className="main__flex">
                        <ContactForm className="form__container">
                            <form onSubmit={sendEmail}>
                                <h2 className="form__title">Write Us</h2>

                                <div className="form__responsive">
                                    <div className="input-field">
                                        <label for ="name">Name</label>
                                        <br/>
                                        <input type="text" id="name" name="name"/>
                                    </div>
                                    <div className="input-field">
                                        <label for ="email">Email Address</label>
                                        <br/>
                                        <input type="email" id="email" name="email"/>
                                    </div>
                                </div>
                                <div className="input-field">
                                    <label for ="subject" name="subject">Subject</label>
                                    <br/>
                                    <input type="text" id="subject"/>
                                </div>
                                <div className="input-field">
                                    <br/>
                                    <label>Message</label>
                                    <textarea name="message"/>
                                </div>
                                <div className="form__btn">
                                    <button>Send Message</button>
                                </div>
                            </form>
                        </ContactForm>
                        <aside>
                            <h2 className="form__title">Contact Winax</h2>
                            <div className="contact__flex">
                                <span><i class="fa fa-clock" aria-hidden="true"></i></span>
                                <div className="contact__caption">
                                    <h3>Working Hours</h3>
                                    <ul>
                                        <li>Mon - Thurs (8:00 AM - 5:00 PM)</li>
                                        <li>Fri - Satur (8:00 AM - 3:00 PM)</li>
                                        <li>Sun (CLOSED)</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="contact__flex">
                                <span><i class="fa fa-map-marker" aria-hidden="true"></i></span>
                                <div className="contact__caption">
                                    <h3>Address</h3>
                                    <ul>
                                        <li>Lower Benue, Makurdi, Benue State</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="contact__flex">
                                <span><i class="fa fa-phone" aria-hidden="true"></i></span>
                                <div className="contact__caption">
                                    <h3>Phone</h3>
                                    <ul>
                                        <li>+234 81 4802 9297</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="contact__flex">
                                <span><i class="fa fa-envelope" aria-hidden="true"></i></span>
                                <div className="contact__caption">
                                    <h3>Email</h3>
                                    <ul>
                                       <a className="contact__mail" href="mailto:winnthako@gmail.com">winnthako@gmail.com</a>
                                    </ul>
                                </div>
                            </div>
                        </aside>
                    </div>
                </div>
            </Main>
            <Map>
                <iframe title="Google map api" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3933.7548624114056!2d6.565779399999999!3d9.6163635!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x104c71cd32cfb0b7%3A0xcf7bf51e9e4a7c04!2sHigh%20level%20makurdi!5e0!3m2!1sen!2sng!4v1637609125774!5m2!1sen!2sng" width="600" height="450" allowfullscreen="" loading="lazy"></iframe>
            </Map>
            <Footer />
        </>
    )
}

const Main = styled.main`

    div.container{
        padding: 50px 20px;

        @media(min-width:1000px){
            padding: 100px;
        }
    }

    div.main__flex{
        display: flex;
        flex-direction: column;

        h2.form__title{
            font-size: 25px;
        }

        h3{
            font-size: 20px;
        }

        @media(min-width: 990px){
            flex-direction: row;
            justify-content: space-between;

            div.form__responsive{
                display: flex;
                justify-content: space-between;
                div{
                    width: 48%;
                }
            }

            aside{
                width: 35%;
            }

            .form__container{
                width: 60%;
            }
        }
    }


    div.main__caption{
        text-align: center;

        @media(min-width: 990px){
            width: 50%;
            margin: 0 auto;

            h2{
                line-height: 50.4px !important;
            }
        }

        span{
            color: rgb(231, 60, 62);
            line-height: 24px;
        }
        h2{
            line-height: 35px;
        }
    }

    aside{
        .contact__flex{
            display: flex;

            span{
                display: inline-block;
                margin-top: 10px;
                font-size: 30px;
                color: rgb(231, 60, 62);
            }
            .contact__caption{
                margin-left: 20px;
                
                h3{
                    line-height: 0;
                }

                ul{
                    list-style: none;
                    padding-left: 0;  
                }
            }
        }

        .contact__mail{
            color: rgb(17, 17, 17);
        }
    }
`
const Banner = styled.div`
    .banner__container{
        color: rgb(255, 255, 255);
        display: flex;
        flex-direction: column;
        z-index: 1;
        position: relative;
        background: black;
        overflow: hidden;

        p{
            color: rgb(255, 255, 255);
        }
    }

    .banner__background{
        background: linear-gradient(rgba(0,0,0,0.3),rgba(0,0,0,0.3)), url("/images/gallery/about1.jpg");
        background-size: cover;
        background-position-x: center;

        background-attachment: fixed;
        position: absolute;
        opacity: 0.3;
        top: 0;
        height: 100%;
        width: 100vw;
        z-index: -1;

    }
    
    .banner__content{
        color: rgb(255, 255, 255);
        max-width: 80%;
        padding: 10% 20px;
        p{
            color: rgb(255, 255, 255);
        }
    }
    
`

const ContactForm = styled.div`

    div.form__btn a{
        background: rgb(231, 60, 62);
        padding: 10px 40px;
        color: white;
        display: inline-block;
        margin-right: 20px;
        border-radius: 5px;
        cursor: pointer;

        @media(max-width: 768px){
            padding: 10px 15px;
        }
    }
    
    div.input-field{
        margin-bottom: 20px;

        input, textarea{
            width: 100%;
        }
        label{
            color: rgb(96, 96, 96);
            font-size: 16px;
            font-weight: 500;
            line-height: 24px;
        }
        input{
            height: 50px;
            border: 1px solid rgb(207, 207, 207);
            font-size: 16px;
            color: rgb(17, 17, 17);
            padding: 0 10px;
        }
        textarea{
            height: 200px;
            border: 1px solid rgb(207, 207, 207);
            font-size: 16px;
            color: rgb(17, 17, 17);
            padding: 10px;
        }
        input:focus, textarea:focus{
            outline: none;
        }
    }

`

const Map = styled.div`
    iframe{
        width: 100vw;
        object-fit: contain;
    }
`

export default Contact
